import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns';
import generatePicker from 'antd/es/date-picker/generatePicker';
import * as dateFns from 'date-fns'
import 'antd/es/date-picker/style/index.css';
import 'antd/es/tag/style';
import 'antd/es/button/style';

const DatePicker = generatePicker(dateFnsGenerateConfig);

const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

export const disabledDateBefore = (current) => {
  const startOfCurrent = dateFns.startOfDay(current)
  const startOfToday = dateFns.startOfDay(new Date())

  return dateFns.isBefore(startOfCurrent, startOfToday)
}

export const disabledTimeBefore = (selected) => {
  const startOfSelected = dateFns.startOfDay(selected)
  const startOfToday = dateFns.startOfDay(new Date())
  const currentHour = dateFns.getHours(new Date())
  const currentMinute = dateFns.getMinutes(new Date())

  const isFutureDate = dateFns.isAfter(startOfSelected, startOfToday)

  return {
    disabledHours: () => isFutureDate ? [] : range(0, currentHour),
    disabledMinutes: () => isFutureDate ? [] : range(0, currentMinute + 1),
    disabledSeconds: () => [],
  };
}

export default DatePicker;